<template>
  <div class="page-banner">
    <div class="logo"></div>
    <div class="subTitle">报表交付工程师培养计划</div>
    <div class="page-title">帆软FCP认证&培训</div>
    <div class="text">
      <img src="../../../assets/coursePage/fcp/box1/icon.png" alt="" />
      项目实操+真题精讲，考试通过率高达90%
    </div>
    <div class="text">
      <img src="../../../assets/coursePage/fcp/box1/icon.png" alt="" />
      泛电商案例全流程体验，夯实报表交付核心能力
    </div>
    <!-- <div class="slogan">
      <span class="left">全网独家合作</span>
      <span class="right">报表交付工程师培养计划</span>
    </div>
    <ul class="info">
      <li>无需编写繁琐代码即可实现整体效率提升</li>
      <li>以培训课+精讲课双重加持，目的让你<br/></li>
      <li>能用会用，顺利通过认证考试</li>
    </ul> -->
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.page-banner {
  height: 600px;
  background-image: url(../../../assets/coursePage/fcp/box1/banner.png);
  background-size: 100% 100%;
  padding: 24px 32px 0 48px;
  box-sizing: border-box;

  .logo {
    width: 240px;
    height: 38px;
    background: url(../../../assets/coursePage/fcp/box1/icon-logo.png);
    background-size: 100% 100%;
    float: right;
  }
  .subTitle {
    width: 436px;
    height: 60px;
    background: url(../../../assets/coursePage/fcp/box1/subTItle.png);
    background-size: 100% 100%;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 60px;
    letter-spacing: 1px;
    text-align: center;
    margin: 80px 0 32px;
  }

  .page-title {
    font-size: 60px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1d2129;
    line-height: 84px;
    letter-spacing: 1px;
    margin-bottom: 52px;
  }

  .slogan {
    width: 472px;
    height: 48px;
    display: flex;
    margin-top: 40px;
    span {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 48px;
    }

    .left {
      width: 176px;
      height: 48px;
      position: relative;
      background: linear-gradient(159deg, #58d1ff 0%, #3c7bff 100%);
      border-radius: 24px;
      color: #ffffff;
      text-align: center;
      z-index: 2;
    }

    .right {
      width: 342px;
      height: 48px;
      position: relative;
      padding-left: 62px;
      z-index: 1;
      color: #0063ff;
      border-radius: 24px;
      border: 1px solid #0063ff;
      margin-left: -46px;
      box-sizing: border-box;
    }
  }

  .info {
    margin-top: 40px;
    li {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #425a7c;
      line-height: 56px;
      padding-left: 21px;
      position: relative;
      &:after {
        content: "·";
        position: absolute;
        top: 0;
        left: 0;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #425a7c;
        line-height: 56px;
      }
    }
    li:last-child {
      &:after {
        content: "";
        display: none;
      }
    }
  }
  .text {
    display: flex;
    align-items: center;
    margin-bottom: 32px;
    margin-bottom: 32px;
    height: 40px;
    img {
      width: 32px;
      height: 32px;
      background-size: contain;
      margin-right: 12px;
    }
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #425a7c;
 
  }
}
</style>
